/**
 * @file Analytics.
 */

import '@elbwalker/walker.js/dist/walker';

/**
 * Analytics component.
 */
const vAnalytics = () => {
	if (!document.body.classList.contains('page-template-template-lifestage-quiz')) {

	const wpPostData   = document.body.dataset;
	const { postSlug } = wpPostData;
	const adminBar     = document.querySelector('#wpadminbar');
	// const header       = document.querySelector('.v-header');
	const speedbump    = document.querySelector('#v-external-speedbump');
	const consent      = document.querySelector('#v-speedbump-oao-consent');
	// const footer       = document.querySelector('.v-footer');
	const ctas         = [...document.querySelectorAll('.v-button')]
		.filter((cta) => {
			let shouldObserver = true;

			if (speedbump.contains(cta)) {
				shouldObserver = false;
			}

			if (consent.contains(cta)) {
				shouldObserver = false;
			}

			if (cta.hasAttribute('data-elb')) {
				shouldObserver = false;
			}

			if (cta.classList.contains('wpcf7-submit')) {
				shouldObserver = false;
			}

			if (cta.getAttribute('href') === '#') {
				shouldObserver = false;
			}

			return shouldObserver;
		});
	const links	     = [...document.querySelectorAll('a:not(.v-unsupported-browser__link):not(.screen-reader-shortcut):not([href^="tel:"]):not([href^="mailto:"]):not([aria-label*="footnote"])')]
		.filter((link) => {
			let shouldObserve = true;
			if (link.classList.contains('v-button')) {
				shouldObserve = false;
			}

			if (speedbump.contains(link)) {
				shouldObserve = false;
			}

			if (consent.contains(link)) {
				shouldObserve = false;
			}

			if (link.hasAttribute('data-elb')) {
				shouldObserve = false;
			}

			if (adminBar && adminBar.contains(link)) {
				shouldObserve = false;
			}

			return shouldObserve;
		});
	const forms      = [...document.querySelectorAll('.wpcf7')];
	const elbLayer   = window.elbwalker || {};
	const siteDomain = window.location.hostname;

	/**
	 * Capitalize each word in a pathname string.
	 *
	 * @returns {string} A capitalized string.
	 */
	/* const getStrigifiedPath = () => {
		const path = window.location.pathname;
		const pathArray = path.split('/').filter((item) => item !== '');

		if (!pathArray.length) {
			return 'Home';
		}

		return pathArray[pathArray.length - 1]
			.replace(/-/g, ' ') // replace dashes with spaces
			.split(' ') // split by spcaces
			.map((w) => w.replace(/\w/, (f) => f.toUpperCase())) // capitalize first letter of each word
			.join(' '); // join back into a string;
	}; */

	/**
	 * Clean a form's title for use in analytics.
	 *
	 * @param {string} title - The form's title. Obtained through innerText.
	 * @returns {string} A cleaned string.
	 */
	const getCleanFormTitle = (title) => {
		const newlineIdx = title.indexOf('\n') < 0 ? title.length : title.indexOf('\n');

		const cleanTitle = title
			.slice(0, newlineIdx) // remove 'Form' from the end of the title
			.replace(/[^a-zA-Z0-9 ]/g, '') // remove special characters
			.replace(/\s+/g, ' ') // replace multiple spaces with single space
			.trim(); // trim whitespace

		return cleanTitle;
	};

	// Track iframe click event
	document.addEventListener('vIframeBtnInit', (e) => {
		const { btn } = e.detail;
		if (!btn || !btn.nodeType === 1) {
			return;
		}

		btn.addEventListener('click', () => {
			const data         = {
				text:        btn.innerText,
				slug:        postSlug,
				href:        'none',
				description: 'Get Life Insurance Quote',
				external:    'false',
			};

			elbLayer.push('quote-now click', data, 'click');
		});
	});

	// Track WPCF7 form submission
	if (forms.length) {
		document.addEventListener('wpcf7mailsent', (e) => {
			const { unitTag } = e.detail;
			const form = document.querySelector(`#${unitTag}`);
			const parent     = form.closest('section, article');
			const title      = parent.querySelector('h2, h3, h4, h5, h6');
			// const slug       = postSlug;
			const data       = {
				slug: postSlug,
				form: getCleanFormTitle(title.innerText),
			};

			elbLayer.push('contact-form submit', data);
		});
	}

	// Bail out if no CTAs, links, or forms are found.
	if (!ctas.length && !links.length) {
		return;
	}

	[...ctas, ...links].forEach((link) => {
		link.addEventListener('click', () => {
			const isCta        = link.classList.contains('v-button');
			const evtName      = isCta ? 'cta click' : 'link click';
			// const slug         = postSlug;
			const text         = link.innerText;
			const heading      = link.closest('h2, h3, h4, h5, h6') ?? link.parentElement.querySelector('h2, h3, h4, h5, h6');
			const { href, id } = link;
			const data         = {
				text,
				slug:        postSlug,
				href,
				description: heading ? heading.innerText : '',
				external:    href ? !href.includes(siteDomain) : 'false',
			};

			if (id) {
				data.description = data.description ? `${data.description} ${id}` : id;
			} else if (isCta && window.location.pathname.includes('education-insights')) {
				data.description = data.description ? `${data.description} blog-cta` : 'blog-cta';
			}

			elbLayer.push(evtName, data, 'click');
		});
	});
}
};

export default vAnalytics;
